import React from 'react';

export const FIELD_STYLE: React.CSSProperties = {
  background: 'var(--bg-input, #1F2937)',
  border: '1px solid var(--border-color, #374151)',
  borderRadius: 4,
  color: 'var(--text-primary, #F3F4F6)',
  padding: '4px 8px',
  fontSize: 12,
  width: '100%',
  outline: 'none',
};

export const ROW: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  marginBottom: 10,
};

export const LABEL: React.CSSProperties = {
  fontSize: 11,
  color: 'var(--text-muted, #6B7280)',
  fontWeight: 500,
};

export const SECTION: React.CSSProperties = {
  fontSize: 10,
  fontWeight: 700,
  color: 'var(--text-muted, #6B7280)',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 8,
  marginTop: 4,
};
